import registrationStore from '../containers/registration/store';
import signUpStore from '../containers/registration/signUp/store';
import requestDemoStore from '../containers/signup/RequestDemoPage/store';
import signupRoleStore from '../containers/signup/SignupRolePage/store';
import signinStore from '../containers/signin/store';
import loginStore from '../containers/registration/login/store';
import forgotPasswordStore from '../containers/registration/forgotPassword/store';
import resetPasswordStore from '../containers/registration/resetPassword/store';
import changePasswordStore from '../containers/registration/changePassword/store';
import userStore from './UserStore';
import uploadTrackStore from '../containers/common/uploadTrack/store';
import trackStore from '../containers/main/track/store';
import projectStore from '../containers/main/project/store';
import looperStore from '../containers/create/looper/store';
import notificationStore from './NotificationStore';
import mainStore from '../containers/main/store';
import studioStore from '../containers/create/studio/store';
import chatStore from '../containers/common/chat/store';
import appStore from '../containers/app/store';
import shareStore from '../containers/share/store';
import inviteMemberStore from './InviteMemberStore';
import searchStore from './SearchStore';
import manageStore from './ManageStore';
import recorderStore from '../components/recorder/store';
import calendarStore from '../containers/main/dashboard/overview/calendar/store';
import changeNameStore from '../containers/main/profile/nameEditor/store';
import audioStore from './AudioStore';
import dialogStore from '../containers/dialog/store';
import statisticsStore from '../containers/main/dashboard/overview/statistics/store';
import discoverStore from '../containers/main/discover/store';
import onBoardingStore from '../containers/main/onBoarding/store';
import groupStore from '../containers/main/groups/store';
import guideStore from '../containers/common/guide/store';
import uploadsProgressStore from '../containers/common/uploadsProgress/store';
import actionStore from './ActionStore';
import schoolStore from '../containers/main/schools/store';
import googleOptimizeStore from './GoogleOptimizeStore';
import timelineStore from '../containers/common/timelineScroll/store';
import wizardStore from '../containers/studio/store';
import notationViewerStore from './NotationViewerStore';
import pricingStore from '../containers/main/pricing/store';
import paymentStore from '../containers/main/payment/store';
import realtimeStore from './RealtimeStore';
import whiteBoardStore from '../containers/studio/whiteboard/store';
import videoChatStore from '../containers/video-chat/store';
import folderStore from './FolderStore';
import assignStudentStore from "../containers/main/lessons-library/AssignStudentStore";
import assignGroupStore from "../containers/main/lessons-library/AssignGroupStore";
import attachStudentStore from "../containers/main/schools/teachers/AttachStudentStore";
import dragStore from "./DragStore";
import studioActionStore from "../containers/studio/actions/store";
import shareLinkStore from './ShareLinkStore';
import iconStore from './IconStore';
import timelineManageStore from './TimelineManageStore'

export default {
    appStore,
    signinStore,
    registrationStore,
    signUpStore,
    requestDemoStore,
    signupRoleStore,
    loginStore,
    forgotPasswordStore,
    resetPasswordStore,
    changePasswordStore,
    userStore,
    uploadTrackStore,
    shareStore,
    trackStore,
    projectStore,
    looperStore,
    notificationStore,
    mainStore,
    studioStore,
    chatStore,
    inviteMemberStore,
    recorderStore,
    searchStore,
    manageStore,
    changeNameStore,
    audioStore,
    calendarStore,
    dialogStore,
    statisticsStore,
    discoverStore,
    onBoardingStore,
    groupStore,
    guideStore,
    uploadsProgressStore,
    notationViewerStore,
    actionStore,
    schoolStore,
    googleOptimizeStore,
    timelineStore,
    wizardStore,
    pricingStore,
    realtimeStore,
    paymentStore,
    whiteBoardStore,
    videoChatStore,
    folderStore,
    assignStudentStore,
    assignGroupStore,
    attachStudentStore,
    dragStore,
    studioActionStore,
    shareLinkStore,
    iconStore,
    timelineManageStore
};
